// src/redux/callEngineReducer.js
import { createSlice } from "@reduxjs/toolkit"

// Lấy engine từ localStorage, nếu chưa có thì mặc định = "jssip"
const savedEngine = localStorage.getItem("callEngine") || "jssip"

const callEngineSlice = createSlice({
  name: "callEngine",
  initialState: { engine: savedEngine },
  reducers: {
    setEngine: (state, action) => {
      state.engine = action.payload
      // Lưu xuống localStorage
      localStorage.setItem("callEngine", action.payload)
    },
  },
})

export const { setEngine } = callEngineSlice.actions
export default callEngineSlice.reducer

